<template>
    <el-dialog width="40%" title="批量导入" :visible.sync="viewDetail" @close="closeModel">
        <el-upload
            style="display: inline-block"
            ref="upload"
            action="123"
            :auto-upload="false"
            :limit="1"
            :show-file-list="false"
            :on-change="(file, fileList) => handleChange(file, fileList)"
            with-credentials
        >
            <el-button type="primary" @click="handleButton">批量导入 </el-button>
            <!--     <span @click="handleButton"
            style="margin-right:20px">批量导入</span> -->
        </el-upload>
    </el-dialog>
</template>

<script>
//importexcel
import { importexcel } from "@/api/erweima/index";
export default {
    props: {},
    data() {
        return {
            viewDetail: true,
            loading: false,
            constitutionFile: [],
        };
    },
    methods: {
        closeModel() {
            this.$emit("closeModel");
        },
        handleButton() {},
        /*本地上传文件状态改变*/
        handleChange(file, fileList) {
            /*   this.constitutionFile.push(file.raw) */
            this.getimportexcel(file);
        },
        //上传
        getimportexcel(file) {
            const formData = new FormData();
            formData.append("file", file.raw);
            formData.append("rebate_id", this.$getSessionStorage("rebate_id"));
            /*  let par = {
        file: formData,
        rebate_id: this.$getSessionStorage('rebate_id')
      } */
            importexcel(formData)
                .then((res) => {
                    if (res.code == 1) {
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error({ message: "导入失败" });
                    }
                })
                .catch((err) => {});
            /*   InvoiceWaitImpor(fd).then(res => {
          if (res.success) {
            this.$message.success(res.msg)
            this.$router.push({
              name: 'issueMakeIn',
            })
 
          } else
            this.$message.error(res.msg)
        }).catch(err => {
        }); */
            /* } */
        },
    },
    components: {},
};
</script>

<style scoped lang="scss">
</style>
